module.exports = __webpack_public_path__ + "static/video-poster-visibuy-a829800419e203b5177423496ec01ee1.png";